import { usePostPortfolioNonLifeInsuranceMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioNonLifeInsuranceMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { NON_LIFE_INSURANCE_FORM_DEFAULT_VALUES } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceFormDefaults";
import { getNonLifeInsuranceFormSchema } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceFormSchema";
import {
	NON_LIFE_INSURANCE_PRODUCT_CATEGORIES,
	type NonLifeInsuranceType,
} from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceTypes";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateNonLifeInsuranceForm = (
	insuranceType: NonLifeInsuranceType,
) => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioNonLifeInsuranceMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getNonLifeInsuranceFormSchema(t),
		defaultValues: NON_LIFE_INSURANCE_FORM_DEFAULT_VALUES,
		mutate: (portfolioFields, options) =>
			mutate(
				{
					...portfolioFields,
					productCategory: NON_LIFE_INSURANCE_PRODUCT_CATEGORIES[insuranceType],
				},
				options,
			),
		successRoute: Routing.Portfolio.PortfolioAddNonLifeInsuranceSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
